/* src/app/components/identity/login-challenge/login-challenge.component.scss */
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #fff;
}
:host-context(.dark-theme) :host ::ng-deep .mat-mdc-progress-spinner circle,
:host-context(.dark-theme) .mat-mdc-progress-spinner circle {
  stroke: black;
}
:host-context(.dark-theme) .mat-mdc-raised-button.mat-primary {
  background-color: #D0A010;
  color: rgba(0, 0, 0, 0.87);
}
:host-context(.dark-theme) .code-prompt {
  color: #f2f2f2;
}
/*# sourceMappingURL=login-challenge.component.css.map */
